import "../css/zto.css";
import { Link } from "react-router-dom";
import { FaPhone } from "react-icons/fa6";
import { LuMail } from "react-icons/lu";
import { IoLocation } from "react-icons/io5";

const Footer = () => {
  return (
    <div className="footer-section">
      <div className="container pb-4">
        <div className="row justify-content-between">
          <div className="col-md-3">
            <div className="office-info">
              <div className="mb-3">
                <p className="fw-bold">Văn phòng Miền Bắc</p>
                <div className="title-text opacity-75">
                  <div className="text-white d-flex">
                    <IoLocation
                      size={32}
                      className=""
                      style={{ marginRight: "0.3rem" }}
                    />
                    41B P. Lý Quốc Sư, Hàng Trống, Hoàn Kiếm, Hà Nội, Việt Nam
                  </div>
                  <div className="text-white mt-2 d-flex align-items-center">
                    <FaPhone
                      size={16}
                      className=""
                      style={{ marginRight: "0.5rem" }}
                    />
                    0364.758.606
                  </div>
                </div>
              </div>
              <div>
                <p className="fw-bold">Văn phòng Miền Nam</p>
                <div className="title-text opacity-75">
                  <div className="text-white d-flex">
                    <IoLocation
                      size={32}
                      className=""
                      style={{ marginRight: "0.3rem" }}
                    />
                    Tôn Đức Thắng, Bến Nghé, Quận 1, Hồ Chí Minh, Việt Nam
                  </div>
                  <div className="text-white mt-2 d-flex align-items-center">
                    <FaPhone
                      size={16}
                      className=""
                      style={{ marginRight: "0.5rem" }}
                    />
                    0364.758.606
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-2">
            <div className="footer-navbar">
              <p className="fw-bold m-0">Về ZTO Việt Nam</p>
              <Link
                to="/#"
                className="title-text d-block opacity-75 text-decoration-none pt-0"
              >
                <span>Trang chủ</span>
              </Link>
              <Link
                to="/about-us"
                className="title-text d-block opacity-75 text-decoration-none"
              >
                <span>Về chúng tôi</span>
              </Link>
              <Link
                to="/news"
                className="title-text d-block opacity-75 text-decoration-none"
              >
                <span>Tin tức</span>
              </Link>
              <Link
                to="/instruction"
                className="title-text d-block opacity-75 text-decoration-none"
              >
                <span>Hướng dẫn</span>
              </Link>
              <Link
                to="/chinh-sach"
                className="title-text d-block opacity-75 text-decoration-none"
              >
                <span>Chính sách</span>
              </Link>
              <Link
                to="/lien-he"
                className="title-text d-block opacity-75 text-decoration-none"
              >
                <span>Liên hệ</span>
              </Link>
            </div>
          </div>
          <div className="col-md-2">
            <div className="service-info">
              <p className="fw-bold m-0">Dịch vụ</p>
              <ul style={{ listStyleType: "none", padding: 0 }}>
                <li className="title-text opacity-75 pt-0">
                  Vận chuyển chính ngạch Trung - Việt
                </li>
                <li className="title-text opacity-75">Vận chuyển Nội địa</li>
                <li className="title-text opacity-75">
                  TTH bằng Nhân dân tệ
                </li>
                <li className="title-text opacity-75">Fulfillment trọn gói</li>
              </ul>
            </div>
          </div>
          <div className="col-md-3">
            <div className="footer-social">
              <p className="fw-bold">Thông tin liên hệ</p>
              <div className="d-flex align-items-center gap-2 title-text mt-0 opacity-75">
                <FaPhone color="#ffffff" />
                <a
                  href="tel:0364758606"
                  className="text-white text-decoration-none"
                >
                  Hotline: 0364.758.606
                </a>
              </div>
              <div className="d-flex align-items-center gap-2 title-text my-2 opacity-75">
                <LuMail size={20} color="#ffffff" />
                <a
                  href="mailto:ztovietnam.vn@gmail.com"
                  className="text-white text-decoration-none"
                >
                  ztovietnam.vn@gmail.com
                </a>
              </div>
              <div className="social-row mt-4">
                <p className="fw-bold">Theo dõi chúng tôi</p>

                <div className="social-links">
                  <div className="social-item d-flex flex-column w-100">
                    <div className="social-media-list">
                      <a
                        href="https://zalo.me/0364758606"
                        className="social-icon"
                      >
                        <svg
                          viewBox="0 0 28 10"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M17.3987 0.00976562C17.4033 1.24213 17.4012 2.4747 17.3991 3.70723V3.70727V3.70731V3.70734C17.3959 5.57472 17.3927 7.442 17.4129 9.30834C17.5598 9.8281 18.0685 9.79427 18.5446 9.76261C18.7306 9.75023 18.9116 9.73819 19.0642 9.75963C19.0552 6.5101 19.0552 3.25929 19.0642 0.00976562H17.3987ZM0.427991 0.12485L0.427381 0.250875C0.424901 0.757311 0.422416 1.26468 0.433163 1.77095C1.62198 1.75802 2.81137 1.76003 4.00056 1.76204H4.00057H4.00058H4.00059C4.59515 1.76304 5.18966 1.76405 5.78403 1.76319C4.78424 3.02594 3.77501 4.28183 2.76573 5.53778L2.76567 5.53785L2.76566 5.53787L2.7656 5.53794L2.76558 5.53796L2.76548 5.53809C2.02303 6.462 1.28055 7.38594 0.541783 8.31266C0.197222 8.70479 0.19013 9.24903 0.183705 9.74203L0.183594 9.75058C1.51244 9.76451 2.8417 9.76264 4.17114 9.76077H4.17121H4.17127H4.17133C5.18599 9.75934 6.20074 9.75791 7.2155 9.7635C7.23801 9.76329 7.26092 9.76324 7.2841 9.7632H7.28428C7.53666 9.76272 7.8215 9.76219 7.9849 9.53722C8.18399 9.27116 8.16838 8.94114 8.15304 8.61674C8.14646 8.47761 8.13994 8.3395 8.15041 8.20792C7.61506 8.20792 7.07971 8.20856 6.54435 8.20919C5.206 8.21077 3.86764 8.21236 2.52929 8.20404C3.40094 7.11818 4.26373 6.02535 5.12658 4.93245C6.00845 3.81547 6.89037 2.69841 7.78188 1.58862C8.12067 1.18001 8.14912 0.629153 8.16723 0.123557C6.33445 0.110695 4.50232 0.115456 2.66945 0.120218C1.92245 0.122159 1.17533 0.124101 0.427991 0.12485ZM23.1931 2.27654C22.0888 2.51059 21.0996 3.24894 20.5875 4.25884C19.9836 5.40322 20.0237 6.85924 20.6884 7.97129C21.5354 9.47644 23.4905 10.2277 25.1237 9.6523C27.0466 9.073 28.2104 6.81139 27.5729 4.90927C27.0647 3.08084 25.05 1.86146 23.1931 2.27654ZM9.43705 3.6304C8.25645 5.02952 8.3224 7.27432 9.5961 8.59197C10.7909 9.95229 13.05 10.2057 14.4879 9.08852C14.5036 9.12373 14.5187 9.16013 14.5341 9.19694C14.6211 9.4061 14.7136 9.62827 14.9379 9.71954C15.197 9.77295 15.4622 9.76814 15.7272 9.76334C15.8471 9.76116 15.967 9.75899 16.0862 9.76221C16.0797 7.33018 16.0823 4.89943 16.0849 2.46869V2.46792C15.8244 2.46921 15.5642 2.46954 15.3041 2.46986H15.3039H15.3037C15.0435 2.47018 14.7833 2.47051 14.5228 2.4718C14.5248 2.53212 14.528 2.62206 14.5312 2.71222L14.5312 2.71309L14.5312 2.71425L14.5313 2.71542L14.5313 2.71628C14.5345 2.80644 14.5377 2.89638 14.5396 2.95671C14.1414 2.7149 13.7289 2.48732 13.2737 2.37223C11.8952 1.97784 10.3306 2.52352 9.43705 3.6304ZM11.5422 3.95657C12.6232 3.49623 13.9797 4.10915 14.3819 5.2031C14.797 6.20912 14.3508 7.4673 13.3849 7.97418C12.3439 8.57159 10.8879 8.11642 10.3707 7.03282C9.76419 5.92077 10.3448 4.37812 11.5422 3.95657ZM26.0573 5.29216C25.6952 4.13097 24.2922 3.46116 23.162 3.92408C22.0293 4.32364 21.4189 5.70207 21.8612 6.81542C22.2271 7.86799 23.4594 8.51195 24.5301 8.18867C25.7521 7.89644 26.4905 6.46499 26.0573 5.29216Z"
                          />
                        </svg>
                      </a>

                      <a
                        href="https://www.facebook.com/ztovietnam"
                        className="social-icon"
                      >
                        <svg
                          viewBox="0 0 16 16"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951" />
                        </svg>
                      </a>

                      <a
                        href="https://www.youtube.com/@ztovietnam"
                        className="social-icon"
                      >
                        <svg
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="copy-right bg-zto p-2">
        Copyright ©2025 - ZTO VIETNAM | LOGISTICS TRUNG - VIỆT
      </div>
    </div>
  );
};

export default Footer;
